module.exports = require('./helpers/bundle-url').getBundleURL('kXTg2') + "logo.7718c6df.svg";